// extracted by mini-css-extract-plugin
export default {"table":"NewBaseTable_table__hD26T","tv-spinner__container-rotate-aLqboHuu":"NewBaseTable_tv-spinner__container-rotate-aLqboHuu__lSe1R","Gradient":"NewBaseTable_Gradient__NhbVN"};